import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import {endpoints} from "@api/apis";
import {Platform} from "react-native";
import {useAppSelector} from "@store/hooks";
import {getParameters, isFromAndroidWebview} from "@app/utils";
import {config, isIframe} from "@voltmoney/micro-frontend";

export const kycDSPInitiate = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.kycDSPInit}${applicationId}`);

}
export const kycDSPInitiateV2 = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.post(`${endpoints.kycDSP}${applicationId}`, {
      redirectionUrl: Platform.OS ==='web' ? `${window.location.href}kyc_redirect` : 'https://app.staging.voltmoney.in'
    });

}
export const kycTATAInitiate = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.post(`${endpoints.kycTATAInit}${applicationId}`, {},
    { headers: { 'Content-Type': 'application/json' }
});

}

export const kycDSPStatus = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.kycDSPStatus}${applicationId}`);

}

export const kycDSPV2Status = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.dspDeepStatus}${applicationId}`);

}

export const kycTATAInitiateURL = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.kycTATAInitURL}${applicationId}`);

}

export const kycTATAStatus = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.kycTATAStatus}${applicationId}`);

}
export const getKYCMode = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.digioMode}${applicationId}`);

}

export type ImportScriptCustomCallbackType = (
    successCB?: (response?: any) => void,
    failureCB?: (response?: any) => void,
    origin?: string,
    extraParams?: Object
) => any;


export const ImportScript = (
    resourceUrl: string,
    customFunction?: ImportScriptCustomCallbackType,
    successCB?: () => void,
    failureCB?: () => void,
    origin?: string
): void => {
    const script = document.createElement('script');
    script.src = resourceUrl;
    script.async = false;
    document.body.appendChild(script);
    script.onload = () => {
        if (successCB && failureCB) {
            customFunction &&
            customFunction(successCB, failureCB, origin);
        } else {
            customFunction && customFunction();
        }
    };
};

export const invokeDigio: ImportScriptCustomCallbackType = async (
    successCB,
    failureCB,
    origin?,
) => {

    let primaryColor = undefined;
    let secondaryColor = undefined;
    let isFromJsSDK = false;
    let isFromPhonePe  = false


    let isFromRnSdk = false
    let isFromRedVision = false
    let isPlainUrl = false

    if(Platform.OS === 'web') {
        const url = window?.location?.href;
        const params = getParameters(url);
        primaryColor = params?.primaryColor;
        secondaryColor = params?.secondaryColor;
        isPlainUrl = url.includes('?') ? false : true;

        if(params?.isFromRnSdk){
            isFromRnSdk = true
        }
        if(params?.isFromJsSDK) {
            isFromJsSDK=true;
        }
    }


  const redirectionUrl = isPlainUrl ? `${window.location.href}?kyc_response=digio` : `${window.location.href}&kyc_response=digio`




    let redirectUrl = isIframe() || (isFromAndroidWebview() && !isFromRedVision && !isFromPhonePe && !isFromRnSdk) || isFromJsSDK ? null : redirectionUrl;

    if (origin && redirectUrl) {
        redirectUrl += `&origin=${origin}`
    }
    const digioOptions = {
        environment: config.DIGIO_ENVIRONMENT,
        callback: function (response: any) {
            if (response.hasOwnProperty('error_code')) {
                failureCB && failureCB(response)
                return console.log('error occurred in process =>', response)
            }
            successCB && successCB(response)
            console.log('Signing completed successfully')
        },
        theme: {
            primaryColor: primaryColor ? `#${primaryColor}` : '#234FDA',
            secondaryColor: secondaryColor ? `#${secondaryColor}` :'#234FDA',
        },
        //@ts-ignore
        logo:  'https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/dsp_finance_logo.png',
        fontFamily: 'Poppins',
        fontUrl:
            'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
        is_iframe:  (isFromAndroidWebview() && !isFromRnSdk && !isFromPhonePe && !isFromRedVision)  ? true : false,
        is_redirection_approach: isIframe() || (isFromAndroidWebview() && !isFromRnSdk && !isFromPhonePe && !isFromRedVision) || isFromJsSDK ? false : true,
        redirect_url: redirectUrl,
    }
    //@ts-ignore
    const digioObj = new Digio(digioOptions)
    //@ts-ignore
    window.digio = digioObj
}

export const digioUtils = {
    init: () => {
        //@ts-ignore
        const digio = window.digio;
        digio && digio.init();
    },
    submit: (
        requestId: string,
        identifier: string,
        token_id?: string,
    ) => {
        //@ts-ignore
        const digio = window.digio;
        digio &&
        digio.submit(requestId, identifier, token_id);
    },
};
